import _definePage_default_0 from '/app/src/pages/index/settings/flow.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/src/pages/[...all].vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/app/src/pages/auth/forgot-password.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/app/src/pages/auth/reset-password.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/app/src/pages/auth/verify-email.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/app/src/pages/auth.vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/',
    name: 'cockpit-layout',
    component: () => import('/app/src/pages/index.vue'),
    children: [
      {
        path: '',
        name: 'main-dashboard',
        component: () => import('/app/src/pages/index/index.vue'),
        /* no children */
        meta: {
          "requiresAuth": true
        }
      },
      {
        path: 'action-list',
        /* internal name: '//action-list' */
        /* no component */
        children: [
          {
            path: '',
            name: '//action-list/',
            component: () => import('/app/src/pages/index/action-list/index.vue'),
            /* no children */
          },
          {
            path: ':result',
            /* internal name: '//action-list/[result]' */
            /* no component */
            children: [
              {
                path: 'form',
                name: '//action-list/[result]/form',
                component: () => import('/app/src/pages/index/action-list/[result]/form.vue'),
                /* no children */
              },
              {
                path: 'survey',
                name: '//action-list/[result]/survey',
                component: () => import('/app/src/pages/index/action-list/[result]/survey.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'analytics',
        /* internal name: '//analytics' */
        /* no component */
        children: [
          {
            path: '',
            name: '//analytics/',
            component: () => import('/app/src/pages/index/analytics/index.vue'),
            /* no children */
          },
          {
            path: 'absence',
            /* internal name: '//analytics/absence' */
            /* no component */
            children: [
              {
                path: 'details',
                name: '//analytics/absence/details',
                component: () => import('/app/src/pages/index/analytics/absence/details.vue'),
                /* no children */
              },
              {
                path: 'table',
                name: '//analytics/absence/table',
                component: () => import('/app/src/pages/index/analytics/absence/table.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'hr',
            /* internal name: '//analytics/hr' */
            /* no component */
            children: [
              {
                path: 'details',
                name: '//analytics/hr/details',
                component: () => import('/app/src/pages/index/analytics/hr/details.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'survey',
            /* internal name: '//analytics/survey' */
            /* no component */
            children: [
              {
                path: ':survey',
                name: '//analytics/survey/[survey]',
                component: () => import('/app/src/pages/index/analytics/survey/[survey].vue'),
                /* no children */
              },
              {
                path: 'dashboard',
                name: '//analytics/survey/dashboard',
                component: () => import('/app/src/pages/index/analytics/survey/dashboard.vue'),
                /* no children */
              },
              {
                path: 'list',
                name: '//analytics/survey/list',
                component: () => import('/app/src/pages/index/analytics/survey/list.vue'),
                /* no children */
              },
              {
                path: 'survey-responses-list',
                name: '//analytics/survey/survey-responses-list',
                component: () => import('/app/src/pages/index/analytics/survey/survey-responses-list.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'availabilities',
        /* internal name: '//availabilities' */
        /* no component */
        children: [
          {
            path: '',
            name: '//availabilities/',
            component: () => import('/app/src/pages/index/availabilities/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'clients',
        /* internal name: '//clients' */
        /* no component */
        children: [
          {
            path: '',
            name: '//clients/',
            component: () => import('/app/src/pages/index/clients/index.vue'),
            /* no children */
          },
          {
            path: ':client',
            /* internal name: '//clients/[client]' */
            /* no component */
            children: [
              {
                path: 'action-list',
                /* internal name: '//clients/[client]/action-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//clients/[client]/action-list/',
                    component: () => import('/app/src/pages/index/clients/[client]/action-list/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'departments',
                /* internal name: '//clients/[client]/departments' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//clients/[client]/departments/',
                    component: () => import('/app/src/pages/index/clients/[client]/departments/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'divisions',
                /* internal name: '//clients/[client]/divisions' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//clients/[client]/divisions/',
                    component: () => import('/app/src/pages/index/clients/[client]/divisions/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'employers',
                /* internal name: '//clients/[client]/employers' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//clients/[client]/employers/',
                    component: () => import('/app/src/pages/index/clients/[client]/employers/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'persons',
                /* internal name: '//clients/[client]/persons' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//clients/[client]/persons/',
                    component: () => import('/app/src/pages/index/clients/[client]/persons/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'contacts',
        /* internal name: '//contacts' */
        /* no component */
        children: [
          {
            path: '',
            name: '//contacts/',
            component: () => import('/app/src/pages/index/contacts/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'current-absences',
        /* internal name: '//current-absences' */
        /* no component */
        children: [
          {
            path: '',
            name: 'current-absences',
            component: () => import('/app/src/pages/index/current-absences/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'departments',
        /* internal name: '//departments' */
        /* no component */
        children: [
          {
            path: '',
            name: '//departments/',
            component: () => import('/app/src/pages/index/departments/index.vue'),
            /* no children */
          },
          {
            path: ':department',
            /* internal name: '//departments/[department]' */
            /* no component */
            children: [
              {
                path: 'action-list',
                /* internal name: '//departments/[department]/action-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//departments/[department]/action-list/',
                    component: () => import('/app/src/pages/index/departments/[department]/action-list/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'persons',
                /* internal name: '//departments/[department]/persons' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//departments/[department]/persons/',
                    component: () => import('/app/src/pages/index/departments/[department]/persons/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'divisions',
        /* internal name: '//divisions' */
        /* no component */
        children: [
          {
            path: '',
            name: '//divisions/',
            component: () => import('/app/src/pages/index/divisions/index.vue'),
            /* no children */
          },
          {
            path: ':division',
            /* internal name: '//divisions/[division]' */
            /* no component */
            children: [
              {
                path: 'action-list',
                /* internal name: '//divisions/[division]/action-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//divisions/[division]/action-list/',
                    component: () => import('/app/src/pages/index/divisions/[division]/action-list/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'departments',
                /* internal name: '//divisions/[division]/departments' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//divisions/[division]/departments/',
                    component: () => import('/app/src/pages/index/divisions/[division]/departments/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'persons',
                /* internal name: '//divisions/[division]/persons' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//divisions/[division]/persons/',
                    component: () => import('/app/src/pages/index/divisions/[division]/persons/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'documents',
        /* internal name: '//documents' */
        /* no component */
        children: [
          {
            path: '',
            name: '//documents/',
            component: () => import('/app/src/pages/index/documents/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'employers',
        /* internal name: '//employers' */
        /* no component */
        children: [
          {
            path: '',
            name: '//employers/',
            component: () => import('/app/src/pages/index/employers/index.vue'),
            /* no children */
          },
          {
            path: ':employer',
            /* internal name: '//employers/[employer]' */
            /* no component */
            children: [
              {
                path: 'action-list',
                /* internal name: '//employers/[employer]/action-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//employers/[employer]/action-list/',
                    component: () => import('/app/src/pages/index/employers/[employer]/action-list/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'departments',
                /* internal name: '//employers/[employer]/departments' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//employers/[employer]/departments/',
                    component: () => import('/app/src/pages/index/employers/[employer]/departments/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'divisions',
                /* internal name: '//employers/[employer]/divisions' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//employers/[employer]/divisions/',
                    component: () => import('/app/src/pages/index/employers/[employer]/divisions/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'persons',
                /* internal name: '//employers/[employer]/persons' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//employers/[employer]/persons/',
                    component: () => import('/app/src/pages/index/employers/[employer]/persons/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'meeting',
        /* internal name: '//meeting' */
        /* no component */
        children: [
          {
            path: ':meeting',
            /* internal name: '//meeting/[meeting]' */
            /* no component */
            children: [
              {
                path: '',
                name: '//meeting/[meeting]/',
                component: () => import('/app/src/pages/index/meeting/[meeting]/index.vue'),
                /* no children */
              },
              {
                path: 'start',
                /* internal name: '//meeting/[meeting]/start' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//meeting/[meeting]/start/',
                    component: () => import('/app/src/pages/index/meeting/[meeting]/start/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'messaging',
        /* internal name: '//messaging' */
        /* no component */
        children: [
          {
            path: '',
            name: '//messaging/',
            component: () => import('/app/src/pages/index/messaging/index.vue'),
            /* no children */
          },
          {
            path: ':uuid',
            name: '//messaging/[uuid]',
            component: () => import('/app/src/pages/index/messaging/[uuid].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'my-calendar',
        /* internal name: '//my-calendar' */
        /* no component */
        children: [
          {
            path: '',
            name: '//my-calendar/',
            component: () => import('/app/src/pages/index/my-calendar/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'notifications',
        /* internal name: '//notifications' */
        /* no component */
        children: [
          {
            path: '',
            name: '//notifications/',
            component: () => import('/app/src/pages/index/notifications/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'persons',
        /* internal name: '//persons' */
        /* no component */
        children: [
          {
            path: '',
            name: '//persons/',
            component: () => import('/app/src/pages/index/persons/index.vue'),
            /* no children */
          },
          {
            path: ':person',
            /* internal name: '//persons/[person]' */
            /* no component */
            children: [
              {
                path: 'absence-history',
                /* internal name: '//persons/[person]/absence-history' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//persons/[person]/absence-history/',
                    component: () => import('/app/src/pages/index/persons/[person]/absence-history/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'action-list',
                /* internal name: '//persons/[person]/action-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//persons/[person]/action-list/',
                    component: () => import('/app/src/pages/index/persons/[person]/action-list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'privacy-legal',
        /* internal name: '//privacy-legal' */
        /* no component */
        children: [
          {
            path: '',
            name: '//privacy-legal/',
            component: () => import('/app/src/pages/index/privacy-legal/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'profile-information',
        /* internal name: '//profile-information' */
        /* no component */
        children: [
          {
            path: '',
            name: '//profile-information/',
            component: () => import('/app/src/pages/index/profile-information/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'settings',
        /* internal name: '//settings' */
        /* no component */
        children: [
          {
            path: '',
            name: '//settings/',
            component: () => import('/app/src/pages/index/settings/index.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'flow',
            name: '//settings/flow',
            component: () => import('/app/src/pages/index/settings/flow.vue'),
            /* no children */
          },
  _definePage_default_0
  )
        ],
      },
      {
        path: 'signatures',
        /* internal name: '//signatures' */
        /* no component */
        children: [
          {
            path: '',
            name: '//signatures/',
            component: () => import('/app/src/pages/index/signatures/index.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "layout": "cockpit"
            }
          }
        ],
      },
      {
        path: 'smart-scheduling',
        /* internal name: '//smart-scheduling' */
        /* no component */
        children: [
          {
            path: '',
            name: 'smart-scheduling',
            component: () => import('/app/src/pages/index/smart-scheduling/index.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "featureFlag": "scheduler.r4_smart"
            }
          }
        ],
      },
      {
        path: 'support',
        /* internal name: '//support' */
        /* no component */
        children: [
          {
            path: '',
            name: '//support/',
            component: () => import('/app/src/pages/index/support/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'tasks',
        /* internal name: '//tasks' */
        /* no component */
        children: [
          {
            path: '',
            name: '//tasks/',
            component: () => import('/app/src/pages/index/tasks/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'timeline',
        /* internal name: '//timeline' */
        /* no component */
        children: [
          {
            path: '',
            name: '//timeline/',
            component: () => import('/app/src/pages/index/timeline/index.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "layout": "cockpit"
            }
          }
        ],
      }
    ],
    meta: {
      "requiresAuth": true
    }
  },
  _mergeRouteRecord(
  {
    path: '/:all(.*)',
    name: '404',
    component: () => import('/app/src/pages/[...all].vue'),
    /* no children */
    meta: {
      "requiresAuth": false
    }
  },
  _definePage_default_2
  ),
  _mergeRouteRecord(
  {
    path: '/auth',
    name: '/auth',
    component: () => import('/app/src/pages/auth.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: 'forgot-password',
        name: '/auth/forgot-password',
        component: () => import('/app/src/pages/auth/forgot-password.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
      {
        path: 'login',
        name: 'auth-login',
        component: () => import('/app/src/pages/auth/login.vue'),
        /* no children */
        meta: {
          "requiresAuth": false
        }
      },
  _mergeRouteRecord(
      {
        path: 'reset-password',
        name: '/auth/reset-password',
        component: () => import('/app/src/pages/auth/reset-password.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
  _mergeRouteRecord(
      {
        path: 'verify-email',
        name: '/auth/verify-email',
        component: () => import('/app/src/pages/auth/verify-email.vue'),
        /* no children */
      },
  _definePage_default_5
  )
    ],
    meta: {
      "requiresAuth": false
    }
  },
  _definePage_default_6
  ),
  {
    path: '/sso',
    name: '/sso',
    component: () => import('/app/src/pages/sso.vue'),
    /* no children */
    meta: {
      "requiresAuth": true
    }
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

